import { PropertyMapper } from '../../decorators';

export class ExpenseReportType {

    @PropertyMapper()
    public id: number;

    @PropertyMapper()
    public name: string;
}
